export default __webpack_public_path__ + "static/media/launcher.7eaa1385.png";